module.exports = __webpack_public_path__ + "img/xmas_point_h.8d7d201f.png";